/**
 * English labels from `taskTemplates.defectOptions` (en) → catalog id.
 * Shared by failure-mode and defect display name helpers.
 */
export const TEMPLATE_DEFECT_NAME_TO_ID = {
  unbalance: 1,
  misalignment: 2,
  'soft foot': 3,
  'structural looseness': 4,
  'rotating looseness': 5,
  'piping stress': 6,
  'belt issue': 7,
  'gear tooth breakage': 8,
  cavitation: 9,
  'hydraulic issue': 10,
  'aerodynamic issue': 11,
  'bent shaft': 12,
  'bearing wear': 13,
  resonance: 14,
  'failed open': 15,
  'failed closed': 16,
  'intermittent leakage': 17,
  'blade/vane defect': 18,
  'blade vane defect': 18,
  'stage 1 bearing wear': 19,
  'stage 2 bearing wear': 20,
  'stage 3 bearing wear': 21,
  'stage 4 bearing wear': 22,
  'gear tooth wear': 23,
  'oil whirl': 24,
  'elliptical stator': 25,
  'elliptical rotor': 26,
  'phasing issue': 27,
  'cracked rotor bars': 28,
  'loose rotor bars': 29,
  'loose windings': 30,
  'electrical unbalance': 31,
  'total harmonic distortion': 32,
};

export function normalizeDefectNameKey(name) {
  if (name == null || typeof name !== 'string') return '';
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}
